import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import { BannerNotificationType } from "../../../components/SimpleBanner";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
// updateObjectInArray is available if you want to optimize local updates
// import { updateObjectInArray } from "../../../shared/utility";
import LaboratoryDetailsForm from "../../../components/forms/setup/laboratories/LaboratoryDetailsForm";

export function LaboratoriesViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [laboratories, setLaboratories] = useState({ data: [], total: 0 });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getLaboratories = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `laboratories?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setLaboratories(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createLaboratory = async function (values) {
    // If values is a FormData (file upload), send it directly. Otherwise send JSON payload.
    let callResult;

    const payload = { ...values };
    callResult = await makePostApiCall("laboratories/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Laboratory added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getLaboratories("", 1);
      }, 1000);
    } else {
      // If unauthorized, force logout. Otherwise show an error banner with backend message when available.
      if (callResult.errorStatus === 401) {
        logout();
        return;
      }

      const message =
        (callResult.data && callResult.data.message) ||
        callResult.errorMessage ||
        "Unable to create laboratory";

      setShowSimpleNotification({
        show: true,
        title: message,
        type: BannerNotificationType.Error,
      });
    }
  };

  const openAddLaboratorySlideOver = (isEdit, item, index) => {
    setSlideOver({
      childComponent: (
        <LaboratoryDetailsForm
          item={item}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit
              ? updateLaboratory(payload, index)
              : createLaboratory(payload)
          }
          title={isEdit ? `Update ${item?.name}` : "Add new laboratory"}
        />
      ),
      open: true,
    });
  };

  const updateLaboratory = async function (values, index) {
    console.log("Updating laboratory with values:", values);
    let callResult = await makePostApiCall(
      `laboratories/${values.id}/update`,
      values
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Laboratory updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      setTimeout(function () {
        getLaboratories("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const deleteLaboratory = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`/laboratories/${id}/delete`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = laboratories.data.filter((item) => item.id !== id);
      setLaboratories({ ...laboratories, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteLaboratory = function (item, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteLaboratory(item.id, index)}
          message={`Are you sure you want to delete  ${item.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    getLaboratories,
    loading,
    laboratories,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteLaboratory,
    openAddLaboratorySlideOver,
  };
}

export default LaboratoriesViewModel;
